import React from "react";
import InputField, { InputType } from "../input/inputField";
import Dropdown from "../Dropdown/dropdown";
import { MultiSelectDropdown } from "../Dropdown/MultiSelectDropdown";
import { MultiOptions } from "../Dropdown/MultiDropdownOptions";
import { DropdownOptions } from "../dropdownOptions";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { SUBJECT_TYPE_OPTIONS } from "../../Constants/options/classType.options";
import { getValue } from "../../utils/object.utils";

interface Props {
  subjectName: string;
  onSubjectNameChange: (subjectName: string) => unknown;
  subjectType: DropdownOptions | null;
  onSubjectTypeChange: (subjectType: DropdownOptions) => unknown;
  selectedClass: DropdownOptions[];
  onClassChange: (classes: DropdownOptions[]) => unknown;
  classMarks: Record<string, number | string>;
  onClassMarksChange: (
    classId: string | number,
    marks: number | string,
  ) => unknown;
}

export const SubjectForm = ({
  subjectName,
  onSubjectNameChange,
  subjectType,
  onSubjectTypeChange,
  selectedClass,
  onClassChange,
  classMarks,
  onClassMarksChange,
}: Props) => {
  const { data: classOptions } = useGetClassesOptions();

  const CLASS_OPTIONS: MultiOptions[] = [
    {
      optionsTitle: "Classes",
      category: "",
      options: classOptions as DropdownOptions[],
    },
  ];

  return (
    <>
      <InputField
        value={subjectName}
        setValue={onSubjectNameChange}
        label={"Subject name"}
        placeHolder="Enter subject name"
      />

      <Dropdown
        label="Subject type"
        options={SUBJECT_TYPE_OPTIONS}
        selectedOption={subjectType}
        setSelectedOption={(option) => {
          onSubjectTypeChange(option);
        }}
      />

      <MultiSelectDropdown
        label="Class"
        allOptions={CLASS_OPTIONS || []}
        selectedOptions={selectedClass}
        setOptions={onClassChange}
      />

      {(selectedClass || []).length > 0 && (
        <div className="flex flex-col gap-3 mt-2">
          {selectedClass.map((classOption) => {
            const classId = String(getValue(classOption, "value", ""));
            return (
              <InputField
                key={classId}
                value={classMarks[classId] ?? ""}
                setValue={(value) => onClassMarksChange(classId, value)}
                label={`${getValue(classOption, "text", "Class")} full marks`}
                placeHolder="Enter full marks"
                type={InputType.Number}
              />
            );
          })}
        </div>
      )}
    </>
  );
};
